import { render, staticRenderFns } from "./fund.vue?vue&type=template&id=3d0abe58&scoped=true&"
import script from "./fund.vue?vue&type=script&lang=js&"
export * from "./fund.vue?vue&type=script&lang=js&"
import style0 from "./fund.vue?vue&type=style&index=0&id=3d0abe58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0abe58",
  null
  
)

export default component.exports